import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { NewsletterModal } from "./components/newsletter/NewsletterModal";
import { CookieBanner } from "./components/CookieBanner";
import { Home } from "./pages/Home";
import { Catalog } from "./pages/Catalog";
import { CalendarPage } from "./pages/CalendarPage";
import { Cities } from "./pages/Cities";
import { EventDetail } from "./pages/EventDetail";
import { PastEvents } from "./pages/PastEvents";
import { Admin } from "./pages/Admin";
import { AboutUs } from "./pages/AboutUs";
import { Terms } from "./pages/Terms";
import { MemberArea } from "./pages/MemberArea";
import { ResetPassword } from "./pages/ResetPassword";
import { EmailVerificationSent } from "./pages/EmailVerificationSent";
import { EmailVerified } from "./pages/EmailVerified";
import AvisoLegal from "./pages/AvisoLegal";
import Privacidad from "./pages/Privacidad";
import PoliticaCookies from "./pages/PoliticaCookies";
import CollectionPage from "./pages/CollectionPage";
import { useAnalytics } from "./hooks/useAnalytics";
import { useGA4 } from "./hooks/useGA4";

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Component to track analytics
function AnalyticsTracker() {
  useAnalytics();
  useGA4();
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[var(--background)]">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogo" element={<Catalog />} />
            <Route path="/calendario" element={<CalendarPage />} />
            <Route path="/ciudades" element={<Cities />} />
            <Route path="/evento/:id" element={<EventDetail />} />
            <Route path="/eventos/:id" element={<EventDetail />} />
            <Route path="/eventos-pasados" element={<PastEvents />} />
            <Route path="/sobre-nosotros" element={<AboutUs />} />
            <Route path="/condiciones" element={<Terms />} />
            {/* Legal Pages */}
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
             {/* Auth */}
            <Route path="/mi-cuenta" element={<MemberArea />} />
            <Route path="/login" element={<MemberArea />} />
            <Route path="/registro" element={<MemberArea />} />
            <Route path="/restablecer-contrasena" element={<ResetPassword />} />
            {/* Verification UX */}
            <Route path="/verificacion-enviada" element={<EmailVerificationSent />} />
            <Route path="/verificado" element={<EmailVerified />} />
            <Route path="/coleccion/:slug" element={<CollectionPage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <NewsletterModal />
        <CookieBanner />
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#121212',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#F5F5F5'
            }
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
